import React from "react";
import {
  StyledStatItem,
  StyledStatItemLabel,
  StyledStatItemValue,
  StyledStatItemIcon,
} from "./InsightCardShared";
import { SvgIconComponent } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface StatItemProps {
  label: string;
  value: string | number;
  icon?: SvgIconComponent;
  labelColor?: string;
  valueColor?: string;
  iconColor?: SvgIconProps["color"];
}

const StatItem: React.FC<StatItemProps> = ({
  label,
  value,
  icon: Icon,
  labelColor,
  valueColor,
  iconColor,
}) => {
  const { t } = useTranslation();

  return (
    <StyledStatItem>
      {Icon && (
        <StyledStatItemIcon>
          <Icon sx={{ fontSize: 20 }} color={iconColor} />
        </StyledStatItemIcon>
      )}
      <StyledStatItemLabel color={labelColor}>{t(label)}</StyledStatItemLabel>
      <StyledStatItemValue color={valueColor}>{value}</StyledStatItemValue>
    </StyledStatItem>
  );
};

export default StatItem;
